const valoresItems = [
    { icon: "fa-solid fa-palette", title: "Cor" },
    { icon: "fa-solid fa-image", title: "Imagem" },
    { icon: "fa-solid fa-volume-high", title: "Áudio" },
    { icon: "fa-solid fa-code-compare", title: "Verdadeiro|Falso" },
    { icon: "fa-solid fa-list-ol", title: "Texto|Número" }
];

const funcoesItems = [
    { icon: "fa-solid fa-shapes", title: "Trigonom." },
    { icon: "fa-solid fa-hashtag", title: "Números" },
    { icon: "fa-solid fa-hashtag", title: "Juntar" },
    { icon: "fa-solid fa-timeline", title: "Linear" },
    { icon: "fa-solid fa-shuffle", title: "Aleatório" }
];

export { valoresItems, funcoesItems };